export const COLOR_SUPPLIERS_SIGNED_UP = '#7B61FF'
export const COLOR_SUPPLIERS_ACTIVATED = '#7B61FF'
export const COLOR_JOBS_OP = '#7B61FF'
export const COLOR_JOBS_CX = '#30A46C'
export const NETWORK_GROWTH_CHART_HEIGHT = 260
export const NETWORK_GROWTH_HISTOGRAM_HEIGHT = 320

export const NETWORK_GROWTH_INFO = [
  'Tracks the growth of the supplier network and its workload, including cumulative ' +
    'supplier sign-ups, suppliers completing their first OP job, jobs completed through ' +
    'OP and CX, and how completed work is distributed across suppliers.',
  'All metrics are cumulative over the selected period. Jobs are assigned to the date of ' +
    'their final delivery signature, while supplier counts include Owner and Transport ' +
    'Controller accounts. Figures are refreshed twice daily, so recent activity may take ' +
    'up to approximately 12 hours to appear.',
].join('\n\n')

export const NETWORK_GROWTH_FOOTNOTES = [
  'All metrics are cumulative and based on the selected time period. Jobs are ' +
    'assigned to the date of their final delivery signature, while supplier ' +
    'counts include Owner and Transport Controller accounts.',
  'Figures are refreshed twice daily, so recent activity may take up to ' +
    'approximately 12 hours to appear.',
]
